import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useAuth0 } from "../auth/react-auth0-wrapper";
var PrivateRoute = function PrivateRoute(_a) {
  var component = _a.component,
    path = _a.path,
    rest = __rest(_a, ["component", "path"]);
  var _useAuth = useAuth0(),
    loading = _useAuth.loading,
    isAuthenticated = _useAuth.isAuthenticated,
    loginWithRedirect = _useAuth.loginWithRedirect;
  useEffect(function () {
    if (loading || isAuthenticated) {
      return;
    }
    var fn = function fn() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = loginWithRedirect;
                if (!_context.t0) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return loginWithRedirect({
                  appState: {
                    targetUrl: window.location.href
                  }
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);
  if (isAuthenticated) return React.createElement(Route, Object.assign({
    path: path,
    component: component
  }, rest));else return null;
};
export default PrivateRoute;